import {inject, Injectable} from '@angular/core';
import {PlanFactExceptionApiService} from "./plan-fact-exception-api.service";
import {PlanFactException} from "../types/release-calendar-types";

@Injectable({
  providedIn: 'root'
})
export class PlanFactExceptionService {
  private planFactExceptionApiService: PlanFactExceptionApiService = inject(PlanFactExceptionApiService);

  public createPlanFactExceptions(planFactException: PlanFactException): Promise<PlanFactException> {
    return new Promise((resolve, reject) => {
      this.planFactExceptionApiService.createPlanFactExceptions(planFactException).subscribe({
        next: (planFactException: PlanFactException) => resolve(planFactException),
        error: (error) => reject(error)
      });
    });
  }

  public updatePlanFactExceptions(planFactException: PlanFactException): Promise<PlanFactException> {
    return new Promise((resolve, reject) => {
      this.planFactExceptionApiService.updatePlanFactExceptions(planFactException).subscribe({
        next: (planFactException: PlanFactException) => resolve(planFactException),
        error: (error) => reject(error)
      });
    });
  }

  public deletePlanFactExceptions(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.planFactExceptionApiService.deletePlanFactExceptions(id).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
